'use client'

import useLogin from '@hooks/useLogin'
import useTrackProperty from '@hooks/useTrackProperty'
import { statsHouseDetail, statsHouseViewTime } from '@plugin/statistics'
import { isSaleData } from '@utils/house'
import Cookies from 'js-cookie'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useMount } from 'react-use'

export default function Stats({
  data
}) {

  const { isLogin } = useLogin()
  const { showTrackProperty } = useTrackProperty()
  const searchParams = useSearchParams()

  useMount(() => {
    window.scrollTo({ top: 0 })
    statsHouseDetail(data.houseId)

    // 默认打开trackhome
    if (searchParams.has('trackhomeId')) {
      showTrackProperty({ house: data, signupSource: 'Track_Home' })()
    }

  })

  return (
    <>
      {
        Boolean(isLogin && isSaleData(data) && data.houseId) && <ViewTime data={data} />
      }
    </>
  )
}

// https://7thave.atlassian.net/browse/HT-3003
// 统计房源详情页的浏览时间
const granularity = 90 * 1000
function ViewTime({
  data
}) {
  useEffect(() => {
    const key = `view_time_${data.houseId}`
    const gap = 1000 * 5 // 5s

    // 每隔5s计算一次浏览时间，超过90s则记录，并且缓存到cookie中
    const intervalId = setInterval(() => {
      const viewTime = Number(Cookies.get(key)) || 0
      const duration = viewTime + gap
      // 超过90s则记录，并重新计时
      if (duration >= granularity) {
        Cookies.remove(key)
        statsHouseViewTime(data.houseId, Math.floor(duration / 1000))
      } else {
        // 今天晚上0点过期
        const expireTime = new Date()
        expireTime.setHours(0, 0, 0, 0)
        expireTime.setDate(expireTime.getDate() + 1)
        // 缓存浏览时间
        Cookies.set(key, duration, { expires: expireTime })
      }
    }, gap)
    return () => clearInterval(intervalId)
  }, [data])
}